if(document.getElementById("cookie-consent-banner")) {
    import("../Components/Vanilla/CookieConsent")
}
if (document.getElementById("product-page-menu")) {
    import("../Components/Vanilla/ProductPageMenu");
}
if (document.getElementsByClassName("variant-list__purchase-wrapper").length > 0 || document.getElementsByClassName("product-detail__purchase-container").length > 0) {
    import("../Components/Vanilla/AddOrRemoveFromInput");
}

if (document.getElementById("quick-search-icon")) {
    import("../Components/Vanilla/HandleStickyMenu");
}
